import { Card, Button } from "@/src/components";
import { useBalances } from "@/src/hooks/useBalances";
import { useStake } from "@/src/hooks/useStake";
import { useAccount } from "wagmi";
import { toast } from "react-hot-toast";
import { useVotes } from "@/src/hooks/useVotes";
import { useState } from "react";

export const VoteButtons = () => {
  const { yes, no, vote_enabled, deadline } = useVotes();
  const { uncharged,charged } = useBalances();
  const { onProposeSupply, onIncreaseSupply, onCancelVote } = useStake();
  const { isConnected } = useAccount();

  const [{ stakeInputReborn }, setInput] = useState({
    stakeInput: "",
    unstakeInput: "",
    stakeInputReborn:"",
  });
  const onInputChangeReborn = (event) => {
    const value = event.target.valueAsNumber;
    const _stakeInput = value;
    setInput({
      stakeInputReborn: _stakeInput
    });
  };

  const onSupply = async () => {
    if (!isConnected) return;

    toast.promise(onProposeSupply(stakeInputReborn), {
      loading: "Transaction is in progress",
      success: "Successfully proposed supply increase ",
      error: (data) => data,
    });
  }
  const onIncrease = async () => {
    if (!isConnected) return;

    toast.promise(onIncreaseSupply(), {
      loading: "Transaction is in progress",
      success: "Successfully proposed supply increase ",
      error: (data) => data,
    });
  }
  const onCancel = async () => {
    if (!isConnected) return;

    toast.promise(onCancelVote(), {
      loading: "Transaction is in progress",
      success: "Successfully proposed supply increase ",
      error: (data) => data,
    });
  }

  return (
    <Card>
      <div className="space-y-4">
        <h3 className="text-sm font-medium text-muted-foreground uppercase tracking-wider">Proposal Actions</h3>
        <div className="space-y-3">
          <div>
            <label className="text-sm text-muted-foreground mb-1.5 block">Supply Amount</label>
            <input
              value={stakeInputReborn}
              max={parseInt(2000000)}
              onChange={onInputChangeReborn}
              className="w-full bg-secondary/50 border border-border rounded-xl px-4 py-3 text-sm text-foreground font-mono placeholder:text-muted-foreground/50 hover:border-primary/40 focus:border-primary focus:ring-1 focus:ring-primary/20 outline-none transition-all"
              type="number"
              required
            />
          </div>
          <Button onClick={onSupply} disabled={vote_enabled===true || (parseInt(uncharged)+parseInt(charged)) === 0 } className="bg-primary/15 text-primary border border-primary/30 hover:bg-primary/25 hover:shadow-none w-full">
            Propose Supply Increase
          </Button>
          <div className="border-t border-border/50" />
          <Button onClick={onIncrease} disabled={parseInt(no) >= parseInt(yes) || vote_enabled===false || (parseInt(uncharged)+parseInt(charged)) === 0 || Date.now()/1000 < (deadline)} className="bg-success/15 text-success border border-success/30 hover:bg-success/25 hover:shadow-none w-full">
            Increase Supply
          </Button>
          <Button onClick={onCancel} disabled={parseInt(yes) > parseInt(no) ||vote_enabled===false ||(parseInt(uncharged)+parseInt(charged)) === 0 || Date.now()/1000 < (parseInt(deadline))} className="bg-destructive/15 text-destructive border border-destructive/30 hover:bg-destructive/25 hover:shadow-none w-full">
            Cancel Vote
          </Button>
        </div>
      </div>
    </Card>

  );
};
